import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var MemberInfo = t.type({
  id: t.string,
  name: t.string,
  title: nullable(t.string),
  company: nullable(t.string),
  avatarUrl: nullable(t.string)
});
var Error = t.type({
  message: t.string
});
export var EditProfileInput = t.type({
  input: t.type({
    name: t.string,
    title: nullable(t.string),
    company: nullable(t.string)
  })
});
export var EditProfileOutput = t.type({
  editProfile: t.union([t.type({
    __typename: t.literal('EditProfileErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditProfileResult'),
    result: MemberInfo
  })])
});
var ImageInput = t.intersection([t.type({
  url: t.string
}), t.partial({
  filestack: nullable(t.type({
    handle: t.string
  }))
})]);
export var UpdateProfileImageInput = t.type({
  input: ImageInput
});
export var UpdateProfileImageOutput = t.type({
  updateProfileImage: t.type({
    __typename: t.literal('UpdateProfileImageOutput'),
    url: t.string
  })
});
export var UpdateOnboardingStatusInput = t.type({
  input: t.type({
    status: t.string
  })
});
export var UpdateOnboardingStatusOutput = t.type({
  updateOnboardingStatus: t.union([t.type({
    __typename: t.literal('UpdateOnboardingStatusError'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('UpdateOnboardingStatusSuccess'),
    newState: t.string
  })])
});